import React, { useContext, useState, useEffect } from 'react'
import { FormSubGroupWrapper, FormSubGroupHeader, FormSubGroupHeading, FormSubGroup } from '../layout'
import { FilterForm } from './FilterForm'
import { StateStore } from '../../containers/StoreProvider'
import { Preferences } from '../../containers/Parameters/types'
import { jobFilterMessages } from './messages'
import { setSuccessNotification, setErrorNotification, dismissNotifications } from '../notification'
import { Loading } from '../responses'
import { useMutation } from '@apollo/client/react'
import { SAVE_PREFERENCES } from './mutation/mutation'
import { SavePreferencesResponse } from './mutation/types'
import { toMutationVariables } from './mutation/toMutationVariables'
import { setErrorNotifications } from '../responses/setErrorNotifications'
import { formatMessageSafe } from '../../util/translateInputOptions'
import { useIntl } from 'react-intl'

import { usePreferences } from '../../containers/Parameters'
import { GET_PREFERENCES } from '../../containers/Parameters/queries'

const JobViewFiltersIntl: React.FunctionComponent = () => {
  const { state } = useContext(StateStore)
  const [loading, setLoading] = useState<boolean>(false)
  const { preferences: userPreferences } = usePreferences()
  const intl = useIntl()
  const formatMessage = formatMessageSafe(intl)

  const scrollTop = () => {
    const body = document.querySelector('body')
    if (body) {
      body.scrollTo(0, 0)
    }
  }

  // For testing error boundary
  const [crash, setCrash] = useState(false)

  const [updateFilters, { loading: mutationLoading }] = useMutation<SavePreferencesResponse>(SAVE_PREFERENCES, {
    refetchQueries: [{ query: GET_PREFERENCES }],
    onCompleted({ savePreferences }) {
      console.log('preferencesData', savePreferences)
      if (savePreferences.__typename === 'SavePreferencesSuccess') {
        setSuccessNotification(
          formatMessage(jobFilterMessages.save_title_success), 
          formatMessage(jobFilterMessages.save_message_success)
        )
      } else {
        setErrorNotifications({ data: savePreferences })
      }
    },
    onError(error) {
      console.error(error)
      return setErrorNotification(
        formatMessage(jobFilterMessages.save_title_error),
        formatMessage(jobFilterMessages.save_message_error)
      )
    },
  })

  const saveFilters = async (values: Preferences) => {
    const id = userPreferences && userPreferences.id ? userPreferences.id : null
    values.id = id
    await updateFilters({ variables: toMutationVariables(values) })
  }

  useEffect(() => {
    scrollTop()
    setTimeout(() => {
      dismissNotifications()
    }, 2000)
  }, [userPreferences])

  return (
    <FormSubGroupWrapper>
      <FormSubGroupHeader>
        <FormSubGroupHeading>Työlistauksen oletussuodatus</FormSubGroupHeading>
      </FormSubGroupHeader>
      <FormSubGroup>
        <FilterForm
          filters={userPreferences?.filters ?? null}
          saveFilters={saveFilters}
          user={state.currentUser}
          loading={loading}
          setLoading={setLoading}
        />
        <Loading loading={loading || mutationLoading} />
      </FormSubGroup>
       {state?.currentUser?.user_id === 740 && (
        <>
          <button onClick={() => setCrash(true)}>Trigger error boundary</button>

          <TestCrash crash={crash} />
        </>
      )}
    </FormSubGroupWrapper>
  )
}

export const JobViewFilters = JobViewFiltersIntl

function TestCrash({ crash }: { crash: boolean }) {
  if (crash) {
    //@ts-ignore
    throw new Error('Testing error boundary with a React error. Should send alert to Slack and Datadog RUM.')
  }

  return <></>
}
